import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-Color-White text-Color-Black font-[Montserrat] Foreground">
      {/* Footer anniversary Logo */}
      <div className="self-stretch px-6 sm:px-12 md:px-24 py-8 sm:py-12 flex justify-center items-center">
        <div className="relative overflow-hidden flex justify-center items-center">
          <img
            src="/assets/AnniLogo.svg"
            alt="Anniversary Logo"
            className="object-contain max-w-full h-auto"
          />
        </div>
      </div>

      {/* default footer */}
      <div className="py-8 sm:py-12 md:py-numbers-40 px-4 sm:px-8 md:px-16 lg:px-numbers-100 border-t">
        <div className="text-button max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8 items-start">
          {/* Logos */}
          <div className="flex flex-row sm:flex-col lg:flex-row items-center justify-center sm:justify-start lg:items-start gap-4 col-span-1 sm:col-span-2 lg:col-span-1">
            <img
              src="/logo-uor.png"
              alt="University Logo"
              className="w-[70px] sm:w-[80px] md:w-[94.65px] max-w-full h-auto"
            />
            <img
              src="/logo-foe.png"
              alt="Faculty Logo"
              className="w-[75px] sm:w-[90px] md:w-[102.42px] max-w-full h-auto"
            />
          </div>

          {/* Address */}
          <div className="flex text-button flex-col gap-2 text-center sm:text-left">
            <div className="flex flex-col sm:flex-row lg:flex-col items-center sm:items-start gap-2">
              <FaMapMarkerAlt className="text-Color-Brand mt-1 flex-shrink-0" />
              <div className="text-sm sm:text-base">
                <p>Faculty of Engineering,</p>
                <p>University of Ruhuna,</p>
                <p>Hapugala, Galle,</p>
                <p>Sri Lanka. 80000</p>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-2 text-center sm:text-left">
            <div className="flex flex-col sm:flex-row lg:flex-col gap-2 items-center sm:items-start">
              <FaPhoneAlt className="text-Color-Brand mt-1 flex-shrink-0" />
              <div className="text-sm sm:text-base">
                <p>+94 912245765,</p>
                <p>+94 912245766,</p>
                <p>+94 912245767</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2 text-center sm:text-left">
            <div className="flex flex-col sm:flex-row lg:flex-col gap-2 items-center sm:items-start">
              <FaEnvelope className="text-Color-Brand flex-shrink-0" />
              <div className="text-sm sm:text-base">
                <p>Fax: +94 912245762</p>
                <p>Email: ar@eng.ruh.ac.lk</p>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex flex-col sm:flex-row lg:flex-col gap-4 items-center sm:items-start lg:items-end col-span-1 sm:col-span-2 lg:col-span-1">
            <p className="font-semibold text-sm sm:text-base">Follow us:</p>
            <div className="flex gap-4 text-Color-Brand text-xl">
              <a
                href="https://www.facebook.com/EfacUOR"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 cursor-pointer transition-transform"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.linkedin.com/company/faculty-of-engineering-university-of-ruhuna/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 cursor-pointer transition-transform"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.youtube.com/@refmedia"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 cursor-pointer transition-transform"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 md:mt-numbers-48 text-center">
          <p className="text-sm sm:text-base">
            © 2025 Faculty of Engineering, University of Ruhuna. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}